import {get} from './api-calls';
import {IPhasesDto} from '../dtos/IPhasesDto';

export const getPhases = (): Promise<IPhasesDto[]> => {
  return get('/phases');
};
